const localOffset = (new Date()).getTimezoneOffset() / 60;

const getLocalDate = (timestamp, utcOffset) =>
  (timestamp * 1000) + ((utcOffset + localOffset) * 3600 * 1000);

const getLocalDateFromDayNumber = (dayNumber, utcOffset) => {
  const now = new Date();
  return getLocalDate((now / 1000) + (dayNumber * 24 * 60 * 60), utcOffset);
};

export { getLocalDateFromDayNumber };
export default getLocalDate;



// WEBPACK FOOTER //
// ./src/utils/getLocalDate.js